export const getUserEmail = () => Office.context.mailbox.userProfile.emailAddress;
